import { IAccountCrudModalLang } from '../../../types/lang'

export const accountCrudModalLang: IAccountCrudModalLang = {
	account_crud_modal: {
		title_create: 'Create account',
		title_edit: 'Edit account',
		title_clone: 'Clone account from base account',
		title_deleted: 'Deleted accounts',
		title_remove_single: 'Remove <span>account</span>',
		title_remove_multiple: 'Remove <span>accounts</span>',
		title_remove_multiple_cnt: 'Remove <span>{{cnt}} selected account(s)</span>',
		field_email_label: 'Email',
		field_email_placeholder: 'Email',
		field_is_active_label: 'Active',
		field_is_active_placeholder: 'Active',
		field_is_fired_label: 'Fired',
		field_role_label: 'Role',
		field_role_placeholder: 'Role',
		field_login_label: 'Login',
		field_login_placeholder: 'Login',
		field_password_label: 'Password',
		field_password_placeholder: 'Password',
		field_kt_group_label: 'KT Group',
		field_kt_group_placeholder: 'KT Group',
		field_date_registered_label: 'Date Registered',
		field_date_registered_placeholder: 'Date Registered',
		msg_remove_confirm: 'Are you sure?',
		msg_resurrect_success: 'Account {{account}} is resurrected successfully!',
		msg_resurrect_error: 'Account {{account}} was NOT resurrected.',
		btn_create: 'Create',
		btn_update: 'Save',
		btn_clone: 'Clone',
		btn_remove: 'Remove',
		btn_close: 'Close'
	}
}